import React from 'react';
import IconType from './iconType';

export default function DollarIcon({ width = 16, height = 17, color = '#424242', ...rest }: IconType) {
  return (
    <svg width={width} height={height} viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
      <circle cx="7.9987" cy="8.4987" r="6.66667" stroke={color} />
      <path d="M8 4.5V12.5" stroke="#424242" strokeLinecap="round" />
      <path
        d="M10 6.83464C10 5.91416 9.10457 5.16797 8 5.16797C6.89543 5.16797 6 5.91416 6 6.83464C6 7.75511 6.89543 8.5013 8 8.5013C9.10457 8.5013 10 9.24749 10 10.168C10 11.0884 9.10457 11.8346 8 11.8346C6.89543 11.8346 6 11.0884 6 10.168"
        stroke={color}
        strokeLinecap="round"
      />
    </svg>
  );
}
